<div class="container">
  <!-- ローディング中 -->
  @if (isLoading) {
    <div class="center">
      <p-progressspinner></p-progressspinner>
    </div>
  }

  <!-- Telegram未連携 -->
  @if (!isLoading && !isRegisteredTelegram) {
    <div>
      <p-message severity="info">この機能を利用するにはTelegram連携が必要です。</p-message>
      <div class="telegram-section">
        <p>以下のボタンからTelegram連携を行ってください。</p>
        <a
          [href]="getTelegramLink()"
          target="_blank"
          (click)="onClickTelegramLink()">
          <p-button
            label="Telegram連携を行う"
            icon="pi pi-send"
            styleClass="p-button-info"></p-button>
        </a>
        <!-- ポーリング中 -->
        @if (isPolling) {
          <div class="polling-status">
            <p-progressspinner
              [style]="{ width: '30px', height: '30px' }"
              strokeWidth="4"></p-progressspinner>
            <span>Telegram連携を確認中...</span>
          </div>
        }
        <!-- タイムアウト -->
        @if (isTimeout) {
          <div>
            <p-message severity="warn">連携がタイムアウトしました。再度お試しください。</p-message>
            <p-button
              label="再試行"
              icon="pi pi-refresh"
              styleClass="p-button-warning"
              (click)="onRetry()"></p-button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Telegram連携済み -->
  @if (!isLoading && isRegisteredTelegram) {
    <div>
      <p-message severity="success">Telegram連携済み: {{ telegramName }}</p-message>
      <!-- SP-APIトークン無効 -->
      @if (!isSpapiTokenValid) {
        <div class="spapi-section">
          <p-message severity="warn">Amazon SP-APIトークンが無効です。再連携を行ってください。</p-message>
          <div class="spapi-reconnect">
            <a [href]="getSpapiReconnectLink()">
              <p-button
                label="Amazon連携を行う"
                icon="pi pi-link"
                styleClass="p-button-danger p-button-lg"></p-button>
            </a>
          </div>
        </div>
      }
      @if (isSpapiTokenValid) {
        <div class="main-content">
          <!-- 追加ボタン -->
          <div class="add-button-row">
            <p-button
              label="追加"
              icon="pi pi-plus"
              [disabled]="isMaxTracksReached"
              (click)="showAddDialog = true"></p-button>
            <p-button
              label="共有商品一覧へ"
              icon="pi pi-bookmark"
              styleClass="p-button-outlined"
              routerLink="/amazon-tracking"></p-button>
            @if (isMaxTracksReached) {
              <span class="max-tracks-message">登録上限（10商品）に達しています</span>
            }
          </div>
          <!-- 追加ダイアログ -->
          <p-dialog
            header="商品追跡を追加"
            [(visible)]="showAddDialog"
            [modal]="true"
            [style]="{ width: '450px' }">
            <div class="dialog-form">
              <div class="form-group">
                <label for="asin-input">ASIN</label>
                <input
                  id="asin-input"
                  type="text"
                  pInputText
                  [(ngModel)]="newAsin"
                  placeholder="例: B0XXXXXXXXX" />
              </div>
              <div class="form-group">
                <label for="threshold-input">閾値価格</label>
                <p-inputnumber
                  id="threshold-input"
                  [(ngModel)]="newThresholdPrice"
                  [min]="1"
                  mode="decimal"
                  [useGrouping]="true"
                  suffix="円"
                  placeholder="例: 3,000円"></p-inputnumber>
              </div>
            </div>
            <ng-template #footer>
              <p-button
                label="キャンセル"
                icon="pi pi-times"
                styleClass="p-button-text"
                (click)="showAddDialog = false"></p-button>
              <p-button
                label="追加"
                icon="pi pi-plus"
                [disabled]="isSubmitting || !newAsin || !newThresholdPrice"
                (click)="onAddTrack()"></p-button>
            </ng-template>
          </p-dialog>
          <!-- 一覧テーブル -->
          @if (isLoadingTracks) {
            <div class="center">
              <p-progressspinner></p-progressspinner>
            </div>
          }
          @if (!isLoadingTracks) {
            <p-table
              [value]="priceTracks"
              [rows]="50"
              [paginator]="priceTracks.length > 50"
              class="p-datatable-sm p-datatable-striped">
              <ng-template #header>
                <tr>
                  <th style="width: 40px">#</th>
                  <th style="width: 60px">画像</th>
                  <th>商品名</th>
                  <th style="width: 100px">ASIN</th>
                  <th style="width: 100px">現在価格</th>
                  <th style="width: 100px">ランキング</th>
                  <th style="width: 120px">閾値価格</th>
                  <th style="width: 120px">操作</th>
                </tr>
              </ng-template>
              <ng-template
                #body
                let-track
                let-rowIndex="rowIndex">
                <tr>
                  <td class="text-center">{{ rowIndex + 1 }}</td>
                  <td>
                    @if (track.amazonProduct.imageUrl) {
                      <img
                        [src]="track.amazonProduct.imageUrl"
                        [alt]="track.amazonProduct.name"
                        class="product-image" />
                    }
                  </td>
                  <td>
                    <a
                      [href]="'https://www.amazon.co.jp/dp/' + track.amazonProduct.asin"
                      target="_blank"
                      class="product-link">
                      {{ track.amazonProduct.name }}
                    </a>
                  </td>
                  <td>{{ track.amazonProduct.asin }}</td>
                  <td class="text-right">{{ track.amazonProduct.latestPrice | number }}円</td>
                  <td class="text-right">{{ track.amazonProduct.latestRanking | number }}</td>
                  <td class="text-right">
                    @if (editingTrackId !== track.id) {
                      <span>{{ track.thresholdPrice | number }}円</span>
                    }
                    @if (editingTrackId === track.id) {
                      <p-inputnumber
                        [(ngModel)]="editThresholdPrice"
                        [min]="1"
                        mode="decimal"
                        [useGrouping]="true"
                        suffix="円"
                        inputStyleClass="edit-threshold-input"></p-inputnumber>
                    }
                  </td>
                  <td>
                    <div class="action-buttons">
                      @if (editingTrackId !== track.id) {
                        <p-button
                          icon="pi pi-pencil"
                          styleClass="p-button-text p-button-sm"
                          (click)="onEditTrack(track)"></p-button>
                        <p-button
                          icon="pi pi-trash"
                          styleClass="p-button-text p-button-danger p-button-sm"
                          (click)="onDeleteTrack(track)"></p-button>
                      }
                      @if (editingTrackId === track.id) {
                        <p-button
                          icon="pi pi-check"
                          styleClass="p-button-text p-button-success p-button-sm"
                          [disabled]="isSubmitting"
                          (click)="onSaveEdit(track)"></p-button>
                        <p-button
                          icon="pi pi-times"
                          styleClass="p-button-text p-button-sm"
                          (click)="onCancelEdit()"></p-button>
                      }
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td
                    colspan="8"
                    class="text-center">
                    追跡中の商品はありません
                  </td>
                </tr>
              </ng-template>
            </p-table>
          }
        </div>
      }
    </div>
  }

  <p-confirmdialog></p-confirmdialog>
</div>
